import { css } from '@emotion/react';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';

export const productNameStyle = css`
  word-break: break-word;
  ${getMediaDown('md')} {
    padding-top: 0.625rem;
  }
`;

const productFontStyle = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 1.125rem;
`;

// styling for horizontal line preceeding product name
export const productLineStyle = css`
  content: '';
  position: absolute;
  top: 2.25rem;
  left: 0;
  width: 1.5625rem;
  height: 0rem;
  border-top: 0.0625rem solid ${getColor('n50')};
  ${getMediaDown('md')} {
    top: 1.625rem;
  }
`;

export const productIconStyle = css`
  display: flex;
  flex-shrink: 0;
  width: 1.875rem;
  padding-right: 0.5rem;
`;

export const productWrapperContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 1rem;
  border-left: 0.0625rem solid ${getColor('n50')};
  ${getMediaDown('md')} {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const productContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${productFontStyle};
  position: relative;
  padding-left: 1.825rem;
  padding-top: 0.875rem;

  ::before {
    ${productLineStyle}
  }

  ${getMediaDown('md')} {
    padding-top: 0rem;
    margin-right: 1.5rem;
    padding-left: 1.875rem;
  }

  .text-input-container label {
    position: relative;
    bottom: -0.1px;
    font-size: 1rem;
  }
`;

export const productInputContainer = css`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: start;
  margin-bottom: 10px;

  > div:first-of-type {
    margin-top: 0rem;
  }

  ${getMediaDown('md')} {
    gap: 0;
    flex-direction: column;
    > div {
      margin-top: 0.625rem;
    }
  }

  .plan-selector {
    width: 12.5rem;
    label {
      font-size: 1rem;
    }
  }
`;

export const userInputContainerStyles = css`
  #user-count-input {
    max-width: 12.5rem;
    min-width: 6rem;
  }

  min-width: 9.25rem;
  max-width: 12.5rem;
`;

export const productLimitStyle = css`
  color: ${getColor('n400')};
  font-size: 0.875rem;
  line-height: 1.125rem;
  letter-spacing: 0rem;
  text-align: left;
  font-weight: 400;
  max-width: 12.5rem;
  margin-top: 5px;
`;

export const maxInputErrorStyle = css`
  .border-error {
    input {
      border: 0.125rem solid red;
    }
  }
  > p {
    color: red;
  }
`;

export const productLimitErrorStyle = css`
  ${productLimitStyle}
  color: red;
  margin-top: 5px;
`;
